import React, { useState } from 'react';
import { useDrag } from '../../hooks/use-drag/index.js';
import editorZoneStyles from '../editor-zone/editor-zone.less.js';
import styles from './drawer.less.js';

const DraggableEdge = (props) => {
    const { align, onDrag, onDragEnd, onDragStart, } = props;
    const edge = 'leftright'.replace(align, '');
    const [cssValue, setCssValue] = useState('');
    const { refCallback } = useDrag({
        onDragStart: () => {
            onDragStart === null || onDragStart === void 0 ? void 0 : onDragStart();
            setCssValue(`* { cursor: col-resize !important; } .${editorZoneStyles['editor-zone']} { transition: none !important; }`);
        },
        onDragEnd: () => {
            onDragEnd === null || onDragEnd === void 0 ? void 0 : onDragEnd();
            setCssValue('');
        },
        onDrag({ x }) {
            if (align === 'left') {
                onDrag === null || onDrag === void 0 ? void 0 : onDrag(x);
            }
            else {
                onDrag === null || onDrag === void 0 ? void 0 : onDrag(document.body.clientWidth - x);
            }
        },
    });
    return (React.createElement("div", { className: styles['draggable-edge'], style: { [edge]: -4 }, ref: refCallback },
        React.createElement("style", { type: "text/css", media: "screen" }, cssValue)));
};

export { DraggableEdge };
//# sourceMappingURL=draggable-edge.js.map
